<div class="dash-content">
  <div class="dash-main-content">

    <!-- Titre & filtres -->
    <div class="dash-top">
      <div style="display: flex; margin-bottom: 3%;">
        <h2 class="dash-title">Audit des actions administratives</h2>

        <div class="dash-action-right">
          <button class="button button-icon neutral" (click)="openDownloadReportDialog()" [disabled]="isLoading"
            title="Télécharger l'audit des applications par IES">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3V15M8 11L12 15L16 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M4 17V19C4 20.1 4.9 21 6 21H18C19.1 21 20 20.1 20 19V17" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" />
            </svg>
            <span>Audit applications par IES</span>
          </button>
        </div>
      </div>
      <div class="dash-action">
        <div class="dash-action-left" [class.controls-disabled]="isLoading">

          <!-- Filtre par type d'opération -->
          <div class="select-wrapper">
            <select (change)="onOperationTypeChange($event)">
              <option value="">Toutes les actions</option>
              @for (op of operationTypes; track op) {
              <option [value]="op.value">{{ op.label }}</option>
              }
            </select>
          </div>

          <!-- Filtre par administrateur -->
          @if (isAdmin) {
          <div class="select-wrapper">
            <select (change)="onAdminChange($event)">
              <option value="">Tous les admins</option>
              @for (admin of adminsList; track admin) {
              <option [value]="admin.id">
                {{ admin.displayName }}
              </option>
              }
            </select>
          </div>
          }

          <!-- Filtre par période -->
          <div class="select-wrapper">
            <select [(ngModel)]="selectedPeriod" (change)="onPeriodChange()">
              <option value="">Toute la période</option>
              <option value="today">Aujourd'hui</option>
              <option value="week">Cette semaine</option>
              <option value="month">Ce mois</option>
              <option value="calendar">Choisir une date</option>
            </select>
          </div>

          <!-- Rechercher -->
          <button class="button button-icon primary" (click)="loadAudit()" [class.controls-disabled]="isLoading">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 17.5L22 22" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
                stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            </svg>
            <span>Rechercher</span>
          </button>

          <!-- Réinitialiser -->
          <!-- <button class="button button-icon secondary" (click)="resetFilters()">
              <span>Réinitialiser</span>
            </button> -->

        </div>
      </div>
    </div>

    <!-- Tableau des événements -->
    <table class="table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Auteur</th>
          <th>Cible</th>
          <th>Action</th>
          <th>Détails</th>
        </tr>

        <!-- Barre de progression sous le header pendant le chargement -->
        @if (isLoading) {
        <tr class="table-loading-row">
          <td colspan="5">
            <div class="table-progress-bar">
              <div class="table-progress-bar-inner"></div>
            </div>
          </td>
        </tr>
        }
      </thead>
      <tbody>
        @if (isLoading) {
        <tr>
          <td colspan="5" style="padding:0; border:none">
            <app-skeleton-table [columns]="['date', 'text-wide', 'text-wide', 'text-wide', 'actions']" [rows]="5"
              [headers]="null" tableClass="">
            </app-skeleton-table>
          </td>
        </tr>
        }
        <!-- <app-loader [loading]="isLoading"></app-loader> -->
        @for (event of paginatedEvents; track event) {
        <tr>
          <td>{{ formatDateTime(event.timestamp) }}</td>
          <td>{{ event.auteur || 'N/A' }}</td>
          <td>{{ event.cible || 'N/A' }}</td>
          <td>
            <div [ngClass]="getEventBadgeClass(event)">
              {{ getEventLabel(event) }}
            </div>
            @if (event.summary) {
            <!-- <div class="event-summary" [title]="event.summary">
              {{ event.summary }}
            </div> -->
            }
          </td>
          <td>
            <button class="button-icon small" (click)="openDetailDialog(event)" title="Voir détails">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 11V16M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                  stroke="#5E5E5E" stroke-width="1.5" stroke-linecap="round" />
                <path d="M12 8H12.01" stroke="#5E5E5E" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>

    <!-- Aucun résultat -->
    @if (!isLoading && filteredEvents.length === 0 && !error) {
    <div class="no-data-message">
      Aucun événement trouvé pour les critères sélectionnés.
    </div>
    }

    <!-- Chargement -->
    <!-- <div *ngIf="isLoading" class="loading-message">
        Chargement des événements...
      </div> -->

    <!-- Erreur -->
    @if (error && !isLoading) {
    <div class="error-message">
      {{ error }}
    </div>
    }

    <!-- Pagination (identique à historiques) -->
    @if (!isLoading && totalPages > 1) {
    <div class="paginate">
      <!-- Bouton précédent -->
      <a (click)="goToPreviousPage()" [class.disabled]="currentPage === 0" class="paginate-arrow left">
        <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path [attr.stroke]="currentPage === 0 ? '#CCCCCC' : 'black'" d="M4.27 7.81L0.75 4.28L4.27 0.75"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
      <!-- Numéros de page -->
      <ul class="paginate-item">
        @for (page of getDisplayPages(); track page) {
        <li [class.is-active]="page === currentPage + 1" [class.dots]="page === '...'">
          @if (page !== '...') {
          <a (click)="goToPage(+page - 1)">{{ page }}</a>
          }
          @if (page === '...') {
          <span>...</span>
          }
        </li>
        }
      </ul>
      <!-- Bouton suivant -->
      <a (click)="goToNextPage()" [class.disabled]="currentPage === totalPages - 1" class="paginate-arrow right">
        <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path [attr.stroke]="currentPage === totalPages - 1 ? '#CCCCCC' : '#5E5E5E'"
            d="M0.75 7.81L4.27 4.28L0.75 0.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </div>
    }

  </div>
</div>